import React, { Component } from 'react'
import { Button } from 'hljd'
import Styles from './style.module.less'
import { observer } from 'mobx-react'
import store from '../../store'

@observer
export default class extends Component {
  componentDidMount() {
    store.getA()
  }
  render() {
    let {
      assigns,
      assignForm: { hotel, fullname, fullphone, created_at }
    } = store

    let historyHtml
    if (assigns.length != 0) {
      historyHtml = assigns.map(v => {
        let _name = '暂无'
        let _fullname = '暂无'
        if (v.merchant) {
          _name = v.merchant.name
          if (v.merchant.hotel_saler_setup.length > 0) {
            _fullname = v.merchant.hotel_saler_setup[0].fullname
          }
        }
        let _html = (
          <dl key={v.id} className={v.call_result == '1' ? '' : Styles.noPhone}>
            <dt>{v.created_at || ''}</dt>
            <dd>
              <p>{_name}</p>
              <span>{_fullname}</span>
            </dd>
          </dl>
        )

        return _html
      })
    } else {
      historyHtml = <div className={Styles.noData} />
    }

    return (
      <div className={Styles.Distr}>
        <div className={Styles.cont}>
          <dl>
            <dt>当前酒店</dt>
            <dd>{hotel}</dd>
          </dl>
          <dl>
            <dt>接单销售</dt>
            <dd>{fullname}</dd>
          </dl>
          <dl>
            <dt>销售电话</dt>
            <dd>{fullphone}</dd>
          </dl>
          <dl>
            <dt>分配时间</dt>
            <dd>{created_at}</dd>
          </dl>
        </div>
        <div className={Styles.FollowUp_col}>
          <h5>历史分配记录</h5>
          <div className={Styles.Fcol}>{historyHtml}</div>
          <div style={{ display: 'none' }} className={Styles.areaBtn}>
            <Button
              style={{ width: 90, marginRight: 8, marginLeft: 13 }}
              type="ghost"
            >
              跟进失败
            </Button>
            <Button style={{ width: 90, marginRight: 8 }} type="ghost">
              定金已付
            </Button>
            <Button style={{ width: 90 }} type="primary">
              确认到店
            </Button>
          </div>
        </div>
      </div>
    )
  }
}
